import { extractNumericValue } from "@widgets/utils";
import { isNumber } from "lodash";

export const ValueCell = ({ dataItem, field }: any) => {
  const renderValue = (value: any) => {
    const actualValue = extractNumericValue(value);

    if (!isNumber(actualValue)) {
      return <span>{value === 0 ? 0 : value || "N/A"}</span>;
    }

    if (actualValue > 0) {
      return <span style={{ color: "var(--positive-color)" }}>{value}</span>;
    }
    return <span style={{ color: "var(--negative-color)" }}>{value}</span>;
  };
  return <div>{renderValue(dataItem[field])}</div>;
};
